/**
 * MFAC variant ↔ MODEL_3D swapper (native Shopify — no CartMagician)
 * CRASH FIX: themes emit EXACTLY ONE model-viewer; this JS updates its src/ios-src
 * + data-shopify-model3d-id from MfacVariantModelMap on variant change.
 * Storewide: overlay glb/usdz from MfacCdnMap asset/inline (R2 r2.dev) when present.
 */
(function () {
  'use strict';

  var MAP_PREFIX = 'MfacVariantModelMap-';
  var ATTR_MODEL_ID = 'data-shopify-model3d-id';
  var ATTR_ACTIVE = 'data-mfac-active-model';

  function parseMap(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function findMaps() {
    var nodes = document.querySelectorAll('script[type="application/json"][id^="' + MAP_PREFIX + '"]');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var map = parseMap(nodes[i]);
      if (!map || !map.byVariantId) continue;
      var sectionId = nodes[i].id.slice(MAP_PREFIX.length);
      out.push({ sectionId: sectionId, el: nodes[i], map: map });
    }
    return out;
  }

  var __mfacCdnMap = null;
  var __mfacCdnMapPromise = null;

  function parseInlineCdnMap() {
    var el = document.getElementById('MfacCdnMap') || document.getElementById('MfacOlowaluCdnMap');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function ensureCdnMap() {
    if (__mfacCdnMap) return Promise.resolve(__mfacCdnMap);
    var inline = parseInlineCdnMap();
    if (inline && inline.byVariantId) {
      __mfacCdnMap = inline;
      return Promise.resolve(__mfacCdnMap);
    }
    if (__mfacCdnMapPromise) return __mfacCdnMapPromise;
    var url = window.MfacCdnMapUrl;
    if (!url) return Promise.resolve(null);
    __mfacCdnMapPromise = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.byVariantId) {
          __mfacCdnMap = j;
          try { bootstrap(); } catch (e) {}
        }
        return __mfacCdnMap;
      })
      .catch(function () { return null; });
    return __mfacCdnMapPromise;
  }

  function getOlowaluCdnMap() {
    // sync path: prefer already-loaded / inline
    if (__mfacCdnMap) return __mfacCdnMap;
    return parseInlineCdnMap();
  }

  function overlayCdnEntry(entry, variantId) {
    if (!entry) return entry;
    var cdn = getOlowaluCdnMap();
    if (!cdn || !cdn.byVariantId) return entry;
    var c = cdn.byVariantId[String(variantId || entry.variantId || '')];
    if (!c) return entry;
    if (c.glb) {
      entry.glb = c.glb;
      // Only overlay usdz when present — empty must not strip iOS Quick Look src
      if (c.usdz) entry.usdz = c.usdz;
      entry.cdn = true;
      entry.cdnBase = cdn.cdn_base || '';
    }
    return entry;
  }

  function resolveEntry(map, variant) {
    if (!map || !variant) return null;
    var byId = map.byVariantId || {};
    var byTitle = map.byVariantTitle || {};
    var idKey = String(variant.id);
    var entry = null;
    if (byId[idKey]) entry = byId[idKey];
    else if (variant.title && byTitle[variant.title]) entry = byTitle[variant.title];
    if (!entry) return null;
    // Shallow copy so CDN overlay does not mutate the parsed map permanently in odd ways
    entry = {
      id: entry.id,
      alt: entry.alt,
      variantTitle: entry.variantTitle || (variant && variant.title) || '',
      variantId: entry.variantId || (variant && variant.id) || '',
      glb: entry.glb,
      usdz: entry.usdz,
      poster: entry.poster
    };
    ensureCdnMap(); // warm cache
    return overlayCdnEntry(entry, idKey);
  }

  function rootForSection(sectionId) {
    return (
      document.getElementById('ProductSection-' + sectionId) ||
      document.querySelector('[data-section-id="' + sectionId + '"]') ||
      document.querySelector('#ProductPhotos-' + sectionId)?.closest('[data-product-images]')?.parentElement ||
      document
    );
  }

  function updateViewer(mv, entry) {
    if (!mv || !entry) return;
    if (entry.glb) mv.setAttribute('src', entry.glb);
    if (entry.usdz) mv.setAttribute('ios-src', entry.usdz);
    else if (entry.usdz === '') mv.removeAttribute('ios-src');
    if (entry.alt) mv.setAttribute('alt', entry.alt);
    if (entry.poster) mv.setAttribute('poster', entry.poster);
    mv.setAttribute('data-model-id', String(entry.id));
    mv.setAttribute(ATTR_ACTIVE, 'true');
    mv.setAttribute('data-mfac-single-model-viewer', '');
    var wrap = mv.closest('[data-product-media-type-model], .product__model-xr-source');
    if (wrap) {
      var sec = wrap.getAttribute('data-media-id') || '';
      var prefix = sec.indexOf('-') !== -1 ? sec.split('-')[0] : '';
      if (prefix) wrap.setAttribute('data-media-id', prefix + '-' + entry.id);
      else wrap.setAttribute('data-media-id', String(entry.id));
    }
  }

  function applyModel(sectionId, entry, map) {
    if (!entry || !entry.id) return false;
    var root = rootForSection(sectionId);
    var xr =
      root.querySelector('[data-mfac-variant-model-swapper], [data-shopify-xr]') ||
      document.querySelector('[data-mfac-variant-model-swapper], [data-shopify-xr]');
    if (xr) {
      xr.setAttribute(ATTR_MODEL_ID, String(entry.id));
      xr.setAttribute(ATTR_ACTIVE, String(entry.id));
    }

    // Prefer the single crash-fix viewer
    var single =
      root.querySelector('model-viewer[data-mfac-single-model-viewer]') ||
      document.querySelector('model-viewer[data-mfac-single-model-viewer]');
    if (single) {
      updateViewer(single, entry);
    } else {
      // Fallback: update matching id, else first viewer
      var viewers = root.querySelectorAll('model-viewer[data-model-id], [data-product-media-type-model] model-viewer');
      if (!viewers.length) viewers = document.querySelectorAll('model-viewer[data-model-id]');
      var matched = null;
      for (var i = 0; i < viewers.length; i++) {
        var mv = viewers[i];
        if (String(mv.getAttribute('data-model-id') || '') === String(entry.id)) {
          matched = mv;
          updateViewer(mv, entry);
        } else {
          mv.removeAttribute(ATTR_ACTIVE);
        }
      }
      if (!matched && viewers.length) updateViewer(viewers[0], entry);
    }

    if (map) map._lastAppliedId = String(entry.id);
    return true;
  }

  function onVariant(variant, preferredSectionId) {
    if (!variant) return;
    var maps = findMaps();
    if (!maps.length) return;
    for (var i = 0; i < maps.length; i++) {
      var item = maps[i];
      if (preferredSectionId && item.sectionId !== String(preferredSectionId)) continue;
      var entry = resolveEntry(item.map, variant);
      if (!entry) continue;
      applyModel(item.sectionId, entry, item.map);
      if (preferredSectionId) break;
    }
  }

  function bootstrap() {
    var maps = findMaps();
    for (var i = 0; i < maps.length; i++) {
      var item = maps[i];
      var initial = item.map.initial || null;
      if (initial && initial.id) {
        initial = {
          id: initial.id,
          alt: initial.alt,
          variantTitle: initial.variantTitle,
          variantId: initial.variantId,
          glb: initial.glb,
          usdz: initial.usdz,
          poster: initial.poster
        };
        overlayCdnEntry(initial, initial.variantId);
        applyModel(item.sectionId, initial, item.map);
      }
    }
  }

  function variantFromEvent(evt) {
    if (!evt || !evt.detail) return null;
    return evt.detail.variant || (evt.detail.detail && evt.detail.detail.variant) || null;
  }

  function sectionIdFromEventTarget(target) {
    if (!target || !target.closest) return null;
    var sec = target.closest('[data-section-id]');
    return sec ? sec.getAttribute('data-section-id') : null;
  }

  document.addEventListener('variantChange', function (evt) {
    onVariant(variantFromEvent(evt), sectionIdFromEventTarget(evt.target));
  });
  document.addEventListener('variant:change', function (evt) {
    onVariant(variantFromEvent(evt), sectionIdFromEventTarget(evt.target));
  });
  document.addEventListener(
    'variantChange',
    function (evt) {
      onVariant(variantFromEvent(evt), sectionIdFromEventTarget(evt.target));
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  try { ensureCdnMap(); } catch (e) {}

  window.MfacVariantModelSwapper = {
    apply: onVariant,
    maps: findMaps,
    resolve: resolveEntry
  };
})();
